function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSticker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 2.5h-6.25A4.38 4.38 0 002.5 6.875v6.25A4.38 4.38 0 006.875 17.5h3.75c.067 0 .134-.01.198-.032 2.05-.683 5.962-4.596 6.645-6.645a.627.627 0 00.032-.198v-3.75A4.38 4.38 0 0013.125 2.5zm-2.5 13.705V13.75a3.129 3.129 0 013.125-3.125h2.455c-.724 1.684-3.896 4.856-5.58 5.58z",
    fill: props.fill
  }));
}

export default SvgSticker;